import { useQuery } from '@tanstack/react-query';
import { RuleItem } from 'models/rules';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { API_FUNCTIONS, queryKeys, RULES_ENDPOINTS, sdk } from 'utils/query';

interface GetRuleProps {
  id?: string;
}

export const getRuleDetail = async ({ id }: GetRuleProps) => {
  if (!id) throw new EmptyParametersError();
  const ruleDetail = await sdk.tasks.api.get<RuleItem>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringRules}/${id}`,
    {},
  );
  const patientId = ruleDetail.targets.patientIds[0];
  const groupId = ruleDetail.recipients.groupIds[0];

  return { ...ruleDetail, patientId, groupId };
};

export const useGetRule = (variables: GetRuleProps) => {
  return useQuery({
    queryKey: [queryKeys.ruleData, variables?.id],
    queryFn: () => getRuleDetail(variables),
    enabled: !!variables?.id,
  });
};
